import React from 'react';
import { Property } from '../../domain/entities/Property';
import { SplitViewCard } from './SplitViewCard';
import PublicMap from '../../../public-map/presentation/components/PublicMap';
import { SplitViewCardSkeleton } from './skeleton/SplitViewCardSkeleton';

export function SplitView({
  mapKey,
  properties,
  isLoading,
  error,
}: {
  mapKey: string;
  properties: Property[];
  isLoading: boolean;
  error: Error | null;
}) {
  // HELEN TODO: Still need to do some responsive diesign work. in the next phase of this ticket!!!!
  // make each card = viewport width on small screens, use horizontal scroll + non-shrinking cards w

  return (
    <div
      id="split-view"
      className="flex flex-grow h-full min-h-0 gap-4 p-4 flex-col sm:flex-row"
    >
      <div
        id="split-view-cards-container"
        className="min-h-0 overflow-auto pr-2 flex flex-col gap-3 w-full sm:w-auto sm:min-w-[735px]"
      >
        {isLoading && (
          <>
            {[...Array(5)].map((_, i) => (
              <SplitViewCardSkeleton key={i} />
            ))}
          </>
        )}
        {error && (
          <div className="flex items-center justify-center p-8 text-red-600 bg-red-50 rounded-lg border border-red-200">
            <div className="text-center">
              <svg
                className="mx-auto h-12 w-12 text-red-400 mb-3"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
                />
              </svg>
              <p className="font-medium">Error loading properties</p>
              <p className="text-sm mt-1">{error.message}</p>
            </div>
          </div>
        )}
        {!isLoading && !error && properties.length === 0 && (
          <div className="flex items-center justify-center p-8 text-gray-500 bg-gray-50 rounded-lg border border-gray-200">
            <div className="text-center">
              <svg
                className="mx-auto h-12 w-12 text-gray-400 mb-3"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"
                />
              </svg>
              <p className="font-medium text-gray-700">No properties found</p>
              <p className="text-sm mt-1">
                Try adjusting your filters to see more results
              </p>
            </div>
          </div>
        )}
        {properties.length > 0 &&
          properties.map((p) => <SplitViewCard key={p.id} property={p} />)}
      </div>

      <div id="split-view-map" className="flex-1  min-h-[50vh]">
        <PublicMap mapKey={mapKey} />
      </div>
    </div>
  );
}
